"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthMeasurement_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var HealthMeasurementType_1 = require("./HealthMeasurementType");
var VitalsRecordVersion_1 = require("./VitalsRecordVersion");
var HealthMeasurement_Factory = /** @class */ (function () {
    function HealthMeasurement_Factory() {
    }
    HealthMeasurement_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Measurement: model.Measurement,
            MeasurementType: HealthMeasurementType_1.HealthMeasurementType_Factory.CreateIncoming(model.MeasurementType),
            MeasurementTypeCode: model.MeasurementTypeCode,
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            VitalsRecordVersions: model.VitalsRecordVersions && model.VitalsRecordVersions.map(function (i) { return VitalsRecordVersion_1.VitalsRecordVersion_Factory.CreateIncoming(i); }),
        };
        return result;
    };
    HealthMeasurement_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Measurement: model.Measurement,
            MeasurementType: HealthMeasurementType_1.HealthMeasurementType_Factory.CreateOutgoing(model.MeasurementType),
            MeasurementTypeCode: model.MeasurementTypeCode,
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            VitalsRecordVersions: model.VitalsRecordVersions && model.VitalsRecordVersions.map(function (i) { return VitalsRecordVersion_1.VitalsRecordVersion_Factory.CreateOutgoing(i); }),
        };
        return result;
    };
    return HealthMeasurement_Factory;
}());
exports.HealthMeasurement_Factory = HealthMeasurement_Factory;
